import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Oyero Habib</title>
    <g>
      <g id="Mark">
        <text
          x="50"
          y="50"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="currentColor"
          fontSize="14"
          fontWeight="700"
          letterSpacing="1.5">
          <tspan x="50" dy="-7">
            OYERO
          </tspan>
          <tspan x="50" dy="18">
            HABIB
          </tspan>
        </text>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
